const LATIN_USA_FORMAT = 'es-ES'

const licenseeDigitFormat = (value, { latinAmericanNumberFormat }) => {
  let digitalValue = value

  if (!value || (typeof value !== 'string' && typeof value !== 'number')) {
    return value
  }

  if (typeof value === 'string') {
    digitalValue = Number(value)
  }

  if (Number.isNaN(digitalValue)) {
    return value
  }

  if (Number.isInteger(digitalValue)) {
    return digitalValue
  }

  if (digitalValue && latinAmericanNumberFormat) {
    return new Intl.NumberFormat(LATIN_USA_FORMAT, {
      useGrouping: false,
    }).format(digitalValue)
  }

  return value
}

export default licenseeDigitFormat
